export default __webpack_public_path__ + "static/media/mixkit-arcade-game-jump-coin-216.ae2de8e7.wav";